import React, { useMemo, useState, useEffect } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor, EuiTextArea, EuiFormControlLayoutDelimited, EuiIcon, EuiSwitch} from '@elastic/eui';
import {ComboSociedadesContainer as ComboSociedades} from '../../../components/Combos/Sociedades/container';
import {ComboFuncionesContainer as ComboFunciones} from '../../../components/Combos/Funciones/container';
import {ComboProyectosContainer as ComboProyectos} from '../../../components/Combos/Proyectos/container';
import {ComboSubFuncionesContainer as ComboSubFunciones} from '../../../components/Combos/SubFunciones/container';
import SelectorFecha from '../../../../../shared/components/Combos/Fecha';
import {ListaAdjuntosContainer as ListadoAdjuntos} from '../../../components/Listas/Adjuntos/container';
import { stringToFloat, toDecimalString } from '../../../../../shared/utils/numbers';
import{ CreateFechaMoment, ToSQL } from '../../../../../shared/utils/fecha';
import { HelpTooltip } from '../../Proyectos/Formulario/help';
import moment from 'moment';

export const FormularioEditarPartes = (props)=>{

  let {onSave,onDownLoad,onRemoveAdjuntos,handleChangeTypeAdjunto,selected, refreshAdjuntos, onClose, perfilUser, user} = props;

  let [fecha, setFecha] = useState(CreateFechaMoment(selected.fecha))

  const getMaxHoras = useMemo(()=>{
    if(fecha.month()+1 < 7 || fecha.month()+1 > 8){
        if(moment(fecha).day()===5){
          return (fecha.year()===2021 && fecha.month()+1 < 7) ? 8 :user.horasViernes;
        }else{
          return (fecha.year()===2021 && fecha.month()+1 < 7) ? 8 : user.horasLunesJueves
        }
    }else{
      return user.horasLunesJuevesContinuo
    }
  },[fecha])

  const parseNHoras = (value) => (stringToFloat(value)*getMaxHoras)/100
  const parsePHoras = (value) => (stringToFloat(value)*100)/getMaxHoras
  
  let [sociedad,setSociedad] = useState(selected.idSociedad)
  let [funcion,setFuncion] = useState(selected.idFuncion)
  let [subFuncion,setSubFuncion] = useState(selected.idSubFuncion)
  let [proyecto,setProyecto] = useState(selected.idProyecto)
  let [nHoras, setNhoras] = useState(selected.nHoras.toString())
  let [pHoras, setPhoras] = useState(parsePHoras(selected.nHoras.toString()))
  let [desplazado, setDesplazado] = useState(selected.desplazado)
  let [observaciones, setObservaciones] = useState(selected.observaciones)
  let [dni,setDni] = useState(selected.dni)
  let [nombre,setNombre] = useState(selected.nombre)
  const [nAdjuntos, setNAdjuntos] = useState(0)

  const onSaveData = () =>{
    let data = {
      idSociedad: sociedad[0].value, 
      idProyecto: (proyecto!==undefined && proyecto.length>0) ? proyecto[0].value : undefined, 
      idFuncion: funcion[0].value, 
      idSubFuncion: subFuncion[0].value, 
      fecha: ToSQL(fecha,"-"), 
      nHoras: nHoras && stringToFloat(nHoras),
      desplazado: desplazado,
      offShore: null,
      observaciones: observaciones,
      dni: dni,
      nombre: nombre
    }
    
    if(comprobarErrores()){
      onSave && onSave({...selected,...data})
    }
  }

  const comprobarErrores = () => {
    return !isInvalidSociedad  && !isInvalidFuncion && !isInvalidSubFuncion && !errorHoras;
  }

  const handleRemoveAdjuntos = (idAdjunto,todos)=>{
    let data ={idParte: selected.idParte, idAdjunto: idAdjunto, todosPartes: todos}
    const errorDesplazado = desplazado === true && nAdjuntos === 1
    return onRemoveAdjuntos && onRemoveAdjuntos(data, errorDesplazado);
  }

  const errorHoras = useMemo(() => {return nHoras===undefined || nHoras.trim()==="" || (isNaN(stringToFloat(nHoras))) || stringToFloat(nHoras)>getMaxHoras},[nHoras,getMaxHoras])
  const isInvalidSociedad = useMemo(() => sociedad===undefined || sociedad.length===0,[sociedad])
  //const isInvalidProyecto = useMemo(() => proyecto===undefined || proyecto.length===0,[proyecto])
  const isInvalidFuncion = useMemo(() => funcion===undefined || funcion.length===0,[funcion])
  const isInvalidSubFuncion = useMemo(() => subFuncion===undefined || subFuncion.length===0,[subFuncion])
  const errorDni = useMemo(() => {return dni===undefined || dni.trim()===""},[nHoras])
  const errorNombre = useMemo(() => {return nombre===undefined || nombre.trim()===""},[nHoras])

  const labelHoras = useMemo(()=>{
    return (
      <span>
      {'Nº Horas Diarias '}
      <HelpTooltip message={`Imputación máxima día (${getMaxHoras} horas)`} position="top" adjust/>
      </span>
    )
  },[])

  const onChangeHoras = (type, value) =>{
    let calc = 0;
    if(type==='p')
    {
      calc = parseNHoras(value)
      setPhoras(value)
      setNhoras(toDecimalString(calc,2))
    }else{
      calc = parsePHoras(value)
      setNhoras(value)
      setPhoras(toDecimalString(calc))
    }
  }

  const onChangeTypeAdjunto = (adjunto)=>{
    const dataType = {IdAdjunto:adjunto.id, IdTipoAdjunto:adjunto.tipo.idTipoAdjunto};
    handleChangeTypeAdjunto&&handleChangeTypeAdjunto(dataType)
  }

  const getNumberAdjuntos = (nAdjuntos) => {setNAdjuntos(nAdjuntos)}

  const msgDesplazado = 'Marcar la casilla si estás desplazado/a a la hora de prestar el servicio. (Se deberá adjuntar documentación justificativa del viaje).'
  
  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow label="Fecha" fullWidth>
            <SelectorFecha fullWidth selected={fecha} onChange={date => setFecha(date)}/>
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow label="Sociedad" isInvalid={isInvalidSociedad}  fullWidth>
            <ComboSociedades fullWidth selectedOptions={sociedad} onChange={value =>{setSociedad(value)}} isInvalid={isInvalidSociedad} user={selected.dni}/>
          </EuiFormRow>
        </EuiFlexItem>
    </EuiFlexGroup>
     
    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow label="Proyecto" fullWidth>
          <ComboProyectos fullWidth dependency
          idSociedad={!isInvalidSociedad ? (Array.isArray(sociedad) ? sociedad[0].value : sociedad) : undefined} 
          selectedOptions={proyecto} onChange={value => setProyecto(value)}/>
          </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    <EuiFlexGroup>
      <EuiFlexItem style={{maxWidth:'50%'}}>
        <EuiFormRow label="Función" isInvalid={isInvalidFuncion} fullWidth>
        <ComboFunciones fullWidth all selectedOptions={funcion} onChange={value => setFuncion(value)} isInvalid={isInvalidFuncion}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem style={{maxWidth:'50%'}}>
        <EuiFormRow label="SubFunción" isInvalid={isInvalidSubFuncion} fullWidth>
          <ComboSubFunciones fullWidth dependency idFuncion={!isInvalidFuncion ? (Array.isArray(funcion) ? funcion[0].value : funcion) : undefined} codArea={selected.codArea} idDN={selected.dn}
          isDisabled={!isInvalidFuncion ? false : true} selectedOptions={subFuncion} onChange={value => setSubFuncion(value)} isInvalid={isInvalidSubFuncion}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    { perfilUser === 'ADM' ? 
      <EuiFlexGroup>
        <EuiFlexItem style={{maxWidth:'50%'}}>
          <EuiFormRow fullWidth label="Dni" isInvalid={errorHoras}>
            <EuiFieldText fullWidth value={dni} name="txtDni" onChange={e => setDni(e.target.value)} isInvalid={errorDni}/>
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem style={{maxWidth:'50%'}}>
          <EuiFormRow fullWidth label="Nombre Usuario">
            <EuiFieldText fullWidth value={nombre} name="txtNombre" onChange={e => setNombre(e.target.value)} isInvalid={errorNombre}/>
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>
    : null}

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFlexGroup>
          <EuiFlexItem>
            <EuiFormRow fullWidth label={labelHoras} isInvalid={errorHoras}>
              <EuiFormControlLayoutDelimited
                isInvalid={errorHoras}
                prepend={'Nº'}
                startControl={
                  <EuiFieldText value={nHoras} name="txtNhoras" onChange={e => onChangeHoras('n',e.target.value)} maxLength={3}/>
                }
                delimiter={<EuiIcon type="merge" />}
                append={'%'}
                endControl={
                  <EuiFieldText value={pHoras} name="txtPhoras" onChange={e => onChangeHoras('p',e.target.value)}maxLength={5}/>
                }
              />
            </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiFormRow fullWidth label="Desplazado/a" labelAppend={<HelpTooltip message={msgDesplazado}/>}>
              <EuiSwitch fullWidth name="chkDesplazado" showLabel={false} checked={desplazado} onChange={()=>setDesplazado(!desplazado)}/>
            </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </EuiFlexGroup>

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Observaciones">
          <EuiTextArea
            fullWidth
            draggable={false}
            compressed
            resize="none"
            rows={2}
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
          />
        </EuiFormRow>
        </EuiFlexItem>
    </EuiFlexGroup>

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Adjuntos">
          <ListadoAdjuntos
            style={{height:"150px", width:"100%!important", maxWidth:"100%", overflowY:"auto"}}
            fullWidth
            idParte={selected && selected.idParte}
            handleDownload={onDownLoad}
            handleRemove={handleRemoveAdjuntos}
            getNumberAdjuntos={getNumberAdjuntos}
            refresh={refreshAdjuntos}
            onChangeTypeAdjunto={onChangeTypeAdjunto}
          />
        </EuiFormRow>
        </EuiFlexItem>
    </EuiFlexGroup>

    {!comprobarErrores() ? 
      <EuiFormRow label="">
        <EuiTextColor color="danger"><br/>{"\nFaltan campos por rellenar o tienen errores"}</EuiTextColor>
      </EuiFormRow>
    :null}
     
    <EuiSpacer size="m" />
    
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={!comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose(refreshAdjuntos)}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>

    </>
      
  )
}
export default FormularioEditarPartes;